import type { Hospital } from '@/types';

export const mockHospitals: Hospital[] = [
  {
    id: 'h_1',
    name: 'Royal Northern Hospital',
    shortName: 'Royal Northern',
    city: 'Sydney',
    state: 'NSW',
    postcode: '2065',
    contactName: 'Dr Helena Wright',
    contactEmail: 'h.wright@rnh.health.nsw.gov.au',
    contactPhone: '+61 2 9000 1234',
    notes: 'Tier-1 teaching hospital. ED & ICU placements year-round.',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'h_2',
    name: 'Bendigo Base Hospital',
    shortName: 'Bendigo Base',
    city: 'Bendigo',
    state: 'VIC',
    postcode: '3550',
    contactName: 'Joseph Marsh',
    contactEmail: 'j.marsh@bendigobase.org.au',
    notes: 'Regional hub — accommodation provided.',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'h_3',
    name: 'Mater Health Brisbane',
    city: 'Brisbane',
    state: 'QLD',
    postcode: '4101',
    contactName: 'Aisha Bell',
    contactEmail: 'aisha.bell@mater.org.au',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'h_4',
    name: 'Cairns & Hinterland HHS',
    shortName: 'Cairns Hospital',
    city: 'Cairns',
    state: 'QLD',
    postcode: '4870',
    contactName: 'Tom Kessler',
    contactEmail: 'tom.kessler@health.qld.gov.au',
    notes: 'Rural generalist & ED roles. Travel + accommodation.',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'h_5',
    name: 'Royal Perth Group',
    city: 'Perth',
    state: 'WA',
    postcode: '6000',
    contactName: 'Niamh Ferreira',
    contactEmail: 'n.ferreira@rphg.health.wa.gov.au',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'h_6',
    name: 'Hobart Private Hospital',
    city: 'Hobart',
    state: 'TAS',
    postcode: '7000',
    contactName: 'Edmund Lyle',
    contactEmail: 'edmund.lyle@hph.com.au',
    createdAt: '2024-04-01T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
];
